import React, { useEffect, useState, createContext } from "react";
import { BrowserRouter } from "react-router-dom";
import $ from "jquery";

import ScrollToTop from "./services/ScrollToTop";
import Header from "./component/common/Header";
import AppRouter from "./Routes/AppRouter";
import Footer_second from "./component/common/Footer_second";
import API from "./api/axios";

// Loader components
import Loadingpage from "./component/common/Loadingpage";
import RepublicDayLoader from "./component/common/RepublicDayLoader";
import ChristmasLoader from "./component/common/loaders/christmasLoader";
import ConfettiE from "./component/common/loaders/ConfettiE";
import ConfettiFinal from "./component/common/loaders/ConfettiFinal";
import SantaAnimation from "./component/common/santaAnimation";
import NewYearLoader from "./component/common/NewYearLoader";
import HoliLoader from "./component/common/HoliLoader";
import HoliStrip from "./component/common/HoliStrip";
import DiwaliLoader from "./component/common/loaders/DiwaliLoader";
import IndependenceDayLoader from "./component/common/IndependenceDayLoader";
import RakshabandhanLoader from "./component/common/RakshabandhanLoader";

export const EventContext = createContext({});

const App = () => {
  const [loading, setLoading] = useState(true);
  const [festival, setFestival] = useState(null);
  const [pathname, setPathname] = useState(window.location.pathname);

  useEffect(() => {
    const navType = performance.getEntriesByType("navigation")[0]?.type;

    const isReload = navType === "reload";
    const loaderShown = sessionStorage.getItem("festivalLoaderShown");

    // Show loader if:
    // 1. First visit
    // 2. OR force reload
    if (!loaderShown || isReload) {
      $("body").css("overflow", "hidden");

      const fetchFestival = async () => {
        try {
          const res = await API.get("/api/public/active-festival");

          const data = res.data?.festival;

          if (data) {
            const today = new Date();
            const start = new Date(data.startDate);
            const end = new Date(data.endDate);

            if (today >= start && today <= end && data.isActive !== false) {
              setFestival(data);
            }
          }
        } catch (err) {
          console.error("Festival API error:", err);
        } finally {
          setTimeout(() => {
            sessionStorage.setItem("festivalLoaderShown", "true");
            setLoading(false);
            $("body").css("overflow", "auto");
          }, 3000);
        }
      };

      fetchFestival();
    } else {
      // No loader
      setLoading(false);
    }
  }, []);

  // Render festival loader dynamically
  const renderLoader = () => {
    if (!festival) return <Loadingpage />;

    switch (festival.loaderType) {
      case "RepublicDayLoader":
        return <RepublicDayLoader />;
      case "IndependenceDayLoader":
        return <IndependenceDayLoader />;
      case "RakshabandhanLoader":
        return <RakshabandhanLoader />;
      case "ChristmasLoader":
        return <ChristmasLoader />;
      case "ConfettiE":
        return <ConfettiE />;
      case "ConfettiFinal":
        return <ConfettiFinal />;
      case "SantaAnimation":
        return <SantaAnimation />;
      case "NewYearLoader":
        return <NewYearLoader />;
      case "HoliLoader":
        return <HoliLoader />;
      case "HoliStrip":
        return <HoliStrip />;
      case "DiwaliLoader":
        return <DiwaliLoader />;
      default:
        return <Loadingpage />;
    }
  };

  if (loading) {
    return (
      <div
        className="conativeLoadingDiv"
        id="loadingdiv"
        style={{ background: "#000" }}
      >
        {renderLoader()}
      </div>
    );
  }

  return (
    <BrowserRouter>
      <EventContext.Provider value={{ festival }}>
        <ScrollToTop />
        <Header />
        <AppRouter />
        <Footer_second pathname={pathname} />
      </EventContext.Provider>
    </BrowserRouter>
  );
};

export default App;
